import { SET_PRODUCT_SLIDER_LIST, SET_PRODUCT_SLIDER_POSITION } from '../constants';

const initialState = {};
export default function blocksReducer(state = initialState, action) {
  switch (action.type) {
    case SET_PRODUCT_SLIDER_POSITION: {
      const initialList = (state || {}).list || [];
      return {
        ...state,
        list: initialList.map((block) => {
          if (block.id === (action.payload || {}).blockId) {
            if (!block.content) {
              block.content = {};
            }
            block.content.position = action.payload.start;
          }
          return block;
        }),
      };
    }
    case SET_PRODUCT_SLIDER_LIST: {
      const initialList = (state || {}).list || [];
      return {
        ...state,
        list: initialList.map((block) => {
          if (block.id === (action.payload || {}).blockId) {
            if (!block.content) {
              block.content = {};
            }
            block.content.list = (action.payload || {}).list || [];
          }
          return block;
        }),
      };
    }
    default:
      return state;
  }
}
